$(document).ready(function() {
  var winW = $(window).width();

  if ( winW < 830 ) {
    $('#main-photo ul').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      infinite: false
    });
    var liSize = $("#main-photo ul li").size();
    $('#main-photo ul').slick('slickRemove', liSize - 1);
  }

  $('#mini-photos ul').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '#main-photo ul',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true
  });

  $('.sizes-chart').click(function() {
    $('#sizing-chart').addClass('show');
    $('.black').addClass('show');
  });

  $('.close-sizes-chart').click(function() {
    $('#sizing-chart').removeClass('show');
    $('.black').removeClass('show');
  });

  // Header
  $('header .icons li .search').click(function() {
    $('.big-search').toggleClass('show');
    $('.black-search').toggleClass('show');
  });

  $('.big-search .cerrar-big-search').click(function() {
    $('.big-search').toggleClass('show');
    $('.black-search').toggleClass('show');
  });

  if ( winW > 830 ) {
    $('header .icons li .cart').click(function() {
      $('#minicart').toggleClass('show');
      $('header .icons li a.search').addClass('white');
      $('header .icons li a.user').addClass('white');
    });
  }

  $('#minicart .cerrar').click(function() {
    $('#minicart').removeClass('show');
  });

  $('header .show-menu').click(function() {
    $('nav').toggleClass('show');
    $(this).toggleClass('close');
  });
  $('header nav .cerrar').click(function() {
    $('nav').removeClass('show');
  });

  $('nav li.site-nav--has-dropdown > a').click(function() {
    $(this).siblings('ul').toggleClass('show');
  });

  // Nav
  $(window).load(function() {
    var bodyH = $('body').height();
    var footerH = $('footer').outerHeight();
    $('.nav-container').height(bodyH - footerH);
    if ( winW > 830 ) {
      $(".product .right .right-inner").stick_in_parent({
        offset_top: 0 
      });
      $(".nav-container nav").stick_in_parent({
        offset_top: 0
      });
    }
  });

  // Product

  $('.product .more-click-0').click(function() {
    $('.product .more-click-0').toggleClass('active');
    $('.product .more-click-1').removeClass('active');
    $('.product .more-click-2').removeClass('active');
    $('.product .more-click-3').removeClass('active');
    $('.more-info-0').toggle(300);
    $('.more-info-1').hide(300);
    $('.more-info-2').hide(300);
    $('.more-info-3').hide(300);
  });

  $('.product .more-click-1').click(function() {
    $('.product .more-click-0').removeClass('active');
    $('.product .more-click-1').toggleClass('active');
    $('.product .more-click-2').removeClass('active');
    $('.product .more-click-3').removeClass('active');
    $('.more-info-0').hide(300);
    $('.more-info-1').toggle(300);
    $('.more-info-2').hide(300);
    $('.more-info-3').hide(300);
  });

  $('.product .more-click-2').click(function() {
    $('.product .more-click-0').removeClass('active');
    $('.product .more-click-2').toggleClass('active');
    $('.product .more-click-1').removeClass('active');
    $('.product .more-click-3').removeClass('active');
    $('.more-info-0').hide(300);
    $('.more-info-2').toggle(300);
    $('.more-info-1').hide(300);
    $('.more-info-3').hide(300);
  });

  $('.product .more-click-3').click(function() {
    $('.product .more-click-0').removeClass('active');
    $('.product .more-click-3').toggleClass('active');
    $('.product .more-click-1').removeClass('active');
    $('.product .more-click-2').removeClass('active');
    $('.more-info-0').hide(300);
    $('.more-info-3').toggle(300);
    $('.more-info-1').hide(300);
    $('.more-info-2').hide(300);
  });

  // $('.product .description .expand').click(function() {
  //   $('.inner-des').toggle(300);
  // });

  $('.product .description .inner-des > div').appendTo('.product .left #main-photo li.video');
  $('.product .description iframe').appendTo('.product .left #main-photo li.video');

  $('.featured-collection ul .item[data-id="4365680934982"]').remove();
  $('.featured-collection ul .item[data-id="4363409293382"]').remove();

  // Page
  $('.esconder').remove();

  // Blog

  // Post

  //$('.post .grid51').wrapAll('<div class="grid-parent" />');

  // Pop Up
  $('#popup .cerrar').click(function() {
    $('#popup').removeClass('show');
  });

  if (!Cookies.get('showed_newsletter')) {
    setTimeout(function() {
      Cookies.set('showed_newsletter', 'true', { expires: 7 });
    },2000) // 3 seconds.
  }

  // Cart
  $('.carrito .more-click-1').click(function() {
    $('.carrito .more-click-1').toggleClass('active');
    $('.carrito .more-click-2').removeClass('active');
    $('.carrito .more-click-3').removeClass('active');
    $('.more-info-1').toggle(300);
    $('.more-info-2').hide(300);
    $('.more-info-3').hide(300);
  });

  $('.carrito .more-click-2').click(function() {
    $('.carrito .more-click-2').toggleClass('active');
    $('.carrito .more-click-1').removeClass('active');
    $('.carrito .more-click-3').removeClass('active');
    $('.more-info-2').toggle(300);
    $('.more-info-1').hide(300);
    $('.more-info-3').hide(300);
  });

  $('.carrito .more-click-3').click(function() {
    $('.carrito .more-click-3').toggleClass('active');
    $('.carrito .more-click-1').removeClass('active');
    $('.carrito .more-click-2').removeClass('active');
    $('.more-info-3').toggle(300);
    $('.more-info-1').hide(300);
    $('.more-info-2').hide(300);
  });

  $('.carrito tr[data-id="31259771732038"]').insertAfter('.carrito tr:last');
  $('.carrito tr[data-id="31268089659462"]').insertAfter('.carrito tr:last');

  $('.carrito tr[data-id="31259771732038"] .td-img > a').removeAttr('href');
  $('.carrito tr[data-id="31259771732038"] .td-name h2 > a').removeAttr('href');
  $('.carrito tr[data-id="31268089659462"] .td-img > a').removeAttr('href');
  $('.carrito tr[data-id="31268089659462"] .td-name h2 > a').removeAttr('href');



});

$(function() {
  var $allVideos = $("iframe[src^='//player.vimeo.com'], iframe[src^='//www.youtube.com'], object, embed"),
  $fluidEl = $("figure");
  $allVideos.each(function() {
    $(this).attr('data-aspectRatio', this.height / this.width).removeAttr('height').removeAttr('width');
  });

  $(window).resize(function() {
    var newWidth = $fluidEl.width();
    $allVideos.each(function() {
      var $el = $(this);
      $el.width(newWidth).height(newWidth * $el.attr('data-aspectRatio'));
    });
  }).resize();
});


var qty = 'Cantidad: ';



/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
 function update_mini_cart(show = false, all = true) {
  $('#minicart .middle ul').empty();
  $("#minicart .cifra").empty();
  jQuery.get(Shopify.routes.root + "cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["product_title"];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5><span class='money'>$" + precio + "</span></h5><h6><span> Quantity: </span> <span>" + cantidad + "</span></h6></div><div class='right'><img src='" + imagen + "' alt='' /></div></li>";
      $("#minicart .middle ul").append(proMini);
    }
    var total     = data.total_price ? data.total_price.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    console.log(data.total_price);
    var itemcount = data.item_count;
    $("#minicart .cifra").append('<span class="money">$' + total + '</span>');
    $("header .icons li a.cart .count").html("(" + itemcount + ")");
    if (show) {
      $('#minicart').addClass('show');
    }
  }, 'json');
}

/**
 * Devuelve el stock de la variante seleccionada
 *
 * @param object stock  Inventario de la ariante
 */

 function get_stock(stock = 0) {
  if (stock == 0) {
    $('.remain p').html('');
    $('#sobre-agregar').fadeIn(100);
  } else if (stock == undefined ) {
    $('#sobre-agregar').fadeIn(100);
  } else if (stock == 1) {
    $('.remain p').html('Queda sólo ' + stock + ' unidad');
    $('#sobre-agregar').fadeOut(100);
  } else {
    $('.remain p').html('');
    $('#sobre-agregar').fadeOut(100);
  }
}
